import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/core'
import {createMarkup} from '../graphql/datoCmsDataFactory'
import {getTheme, getThemeStyles} from '../util/theme'
import {getLanguageCode} from '../util/locale'

import Layout from '../components/Layout'

import verifyData from '../translations/verify.json'

const Verify = ({languageCode}) => {
    const detectedLang = languageCode || getLanguageCode()
    // fall back to English for languages we don't have copy for
    const lang = verifyData[detectedLang] ? detectedLang : 'en'

    const {seo, pageTitle, sections} = verifyData[lang]

    const [theme, setTheme] = useState('light')
    const [themeStyles, setThemeStyles] = useState({})

    useEffect(() => {
        setTheme(getTheme())
        setThemeStyles(getThemeStyles())
    }, [theme, themeStyles])

    return (
        <Layout
            title={seo.title}
            description={seo.description}
            lang={lang}
            canonicalPath="/verify/"
            theme={theme}
            themeStyles={themeStyles}
        >
            <div
                css={css`
                    color: ${themeStyles.primaryTextColor};
                    background-color: ${themeStyles.primaryBackgroundColor};
                    margin: 5.4rem 0 0;
                    padding-top: 50px;

                    @media (min-width: 900px) {
                        padding-top: 60px;
                    }
                `}
                className="verify-page"
            >
                <section
                    className="verify-page__content"
                    css={css`
                        max-width: 800px;
                        margin: 0 auto;
                        padding: 0 16px 64px;

                        @media (min-width: 900px) {
                            padding-left: 40px;
                            padding-right: 40px;
                        }
                    `}
                >
                    <h1
                        css={css`
                            color: ${themeStyles.primaryTextColor};
                            font-weight: 700;
                            font-size: 38px;
                            line-height: 46px;
                            letter-spacing: 0.33px;
                            margin-bottom: 24px;

                            @media (min-width: 900px) {
                                font-size: 46px;
                                line-height: 48px;
                            }
                        `}
                    >
                        {pageTitle}
                    </h1>
                    {sections.map((section, sectionIndex) => (
                        <div key={section.title}>
                            <h2
                                css={css`
                                    color: ${themeStyles.primaryTextColor};
                                    font-weight: 700;
                                    font-size: 22px;
                                    line-height: 28px;
                                    letter-spacing: 0.33px;
                                    margin: ${sectionIndex === 0 ? '8px' : '40px'} 0 0;

                                    @media (min-width: 900px) {
                                        font-size: 24px;
                                        line-height: 32px;
                                    }
                                `}
                            >
                                {section.title}
                            </h2>
                            {section.paragraphs.map((paragraph, i) => (
                                <p
                                    // eslint-disable-next-line react/no-array-index-key
                                    key={i}
                                    css={css`
                                        color: ${themeStyles.primaryTextColor};
                                        font-size: 14px;
                                        line-height: 24px;
                                        font-weight: normal;
                                        margin-top: 24px;

                                        a {
                                            color: ${themeStyles.emphasisTextColor};
                                        }

                                        @media (min-width: 900px) {
                                            font-size: 16px;
                                            line-height: 28px;
                                        }
                                    `}
                                    dangerouslySetInnerHTML={createMarkup(paragraph)}
                                />
                            ))}
                        </div>
                    ))}
                </section>
            </div>
        </Layout>
    )
}

Verify.propTypes = {
    languageCode: PropTypes.string,
}

export default Verify
